import request from '@/utils/request';

const requestInstance = request();

/**
 * 读取开发者，包含未开通
 * @returns {*}
 */
export function getDeveloper() {
  return requestInstance.post('/api/developer/getDeveloper');
}

/**
 * 创建开发者
 * @returns {*}
 */
export function createDeveloper(parameter) {
  return requestInstance.post('/api/developer/create', parameter);
}

/**
 * 修改开发者
 * @returns {*}
 */
export function uploadDeveloper(parameter) {
  return requestInstance.post('/api/developer/update', parameter);
}
